import { render, staticRenderFns } from "./ParamsTemplateRecommendations.vue?vue&type=template&id=da9537f2&scoped=true"
import script from "./ParamsTemplateRecommendations.vue?vue&type=script&lang=js"
export * from "./ParamsTemplateRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9537f2",
  null
  
)

export default component.exports